import React from "react";

const CompleteProbationAction = () => {
    return (
        <div>
            Complete Probation Action
        </div>
    );
}

export default CompleteProbationAction;